import { useState, useEffect, useCallback } from "react";

const changeHash = (newHash) => {
  var oldHash = (window.location.hash || "").replace("#", "");
  if (oldHash !== newHash) {
    window.history.pushState(
      null,
      "",
      `${
        window.location.pathname + window.location.search
      }#${newHash.replaceAll(/^#*/g, "")}`
    );
  }
};

const useHash = (onChangeFn) => {
  const [hash, setHash] = useState(() => window.location.hash);

  const hashChangeHandler = useCallback(() => {
    setHash((prev) => {
      const next = window.location.hash;
      if (prev !== next && typeof onChangeFn === "function") {
        onChangeFn(prev, next);
      }
      return next;
    });
  }, [onChangeFn]);

  useEffect(() => {
    window.addEventListener("hashchange", hashChangeHandler);
    return () => {
      window.removeEventListener("hashchange", hashChangeHandler);
    };
  }, [hashChangeHandler]);

  const push = useCallback(
    (newHash) => {
      changeHash(newHash);
      hashChangeHandler();
    },
    [hashChangeHandler]
  );

  const replace = useCallback(
    (newHash) => {
      var oldHash = (window.location.hash || "").replace("#", "");
      if (oldHash !== newHash) {
        window.history.replaceState(
          null,
          "",
          `${window.location.pathname + window.location.search}#${newHash}`
        );
        hashChangeHandler();
      }
    },
    [hashChangeHandler]
  );

  return [hash, push, replace];
};

export default useHash;
